
<div  *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">

    <div class="row " *ngIf="!view270&& !view271client">
      <div class="col pl-3">
        <h4 class="mb-0 font-header" style="font-weight: 700;">Eligibility</h4>
      </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
      <div class="row mt-4 ">
        <div class="col ">
          <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
              <div class="text-center text-danger">
                <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                  agency to view
                  details</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!view270&& !view271client">
      <div class="row mb-2 mt-2"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col ">
          <div class="card-body  widget-body pb-0 pt-2 ">
          </div>
          <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
              <div class="row">
                <div class=" col-lg-4 col-md-6 col-sm-6 col-xs-12 text_right  font-header ">
                  <button type="button" class="btn blue-btn btn-sm ms-1"
                    (click)="view270=true;view271client=false; view270filedata()"
                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null">
                    View 270
                  </button>
                  <button type="button" class="btn blue-btn btn-sm ms-1"
                    (click)="view271client=true;view270=false;"
                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null">
                    View 271
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <section id="tabs" class="project-tab">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-md-12">
                          <nav>
                            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                              <a class="nav-item nav-link active" id="nav-270-tab" data-bs-toggle="tab" href="#nav-270"
                                role="tab" aria-controls="nav-270" aria-selected="true"
                                (click)="view271client=false">Generate 270</a>
                              <a class="nav-item nav-link " id="nav-271-tab" data-bs-toggle="tab" href="#nav-271" role="tab"
                                aria-controls="nav-271" (click)="view271filedata();view271client=false"
                                aria-selected="false">Import 271</a>
                            </div>
                            <div class="tab-content mt-3" id="nav-tabContent">
                              <div class="tab-pane fade show active" id="nav-270" role="tabpanel"
                                aria-labelledby="nav-Service-tab" *ngIf="global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
                                <div class="row">
                                  <div class="col-lg-6" style="border-right: solid 4px #004092;">
                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <label>Group<sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                      </div>
                                      <div class="col-lg-6 d-flex">
                                        <ng-select [(ngModel)]="generate270.groupId" [searchable]="true" [clearable]="true"
                                          [items]="groupList" bindLabel="lovValue" class="tdropdown w-100" bindValue="id"
                                          [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null"
                                          (ngModelChange)="getpayorList()">
                                        </ng-select>
                                        <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')"></app-dropdown>
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <label>Payor<sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                      </div>
                                      <div class="col-lg-6">
                                        <ng-select [(ngModel)]="generate270.payorId" [searchable]="true" [clearable]="true"
                                          [items]="payorList" bindLabel="Value" (ngModelChange)="getCompanyList()"
                                          [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null || generate270.groupId=='00000000-0000-0000-0000-000000000000'||
                                          generate270.groupId==null||generate270.groupId==undefined  " class="tdropdown"
                                          bindValue="Key">
                                        </ng-select>
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <label>Company<sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                      </div>
                                      <div class="col-lg-6">
                                        <ng-select [(ngModel)]="generate270.companyId" [searchable]="true"
                                          [clearable]="true" [items]="companyList" bindLabel="Value"
                                          [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'
                                          ||generate270.payorId==null || generate270.payorId==undefined || generate270.payorId=='00000000-0000-0000-0000-000000000000'" class="tdropdown" bindValue="Key">
                                        </ng-select>
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <label>ClearingHouse<sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                      </div>
                                      <div class="col-lg-6">
                                        <ng-select [(ngModel)]="generate270.clearingHouseId" [searchable]="true"
                                          [clearable]="true" [items]="clearingHouseList" bindLabel="Value"
                                          [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null"
                                          class="tdropdown" bindValue="Key">
                                        </ng-select>
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-lg-9">
    
                                      </div>
                                      <div class="col-lg-3">
                                        <button type="button" class="btn blue-btn"
                                          [disabled]="generate270.groupId=='00000000-0000-0000-0000-000000000000'||generate270.groupId==null ||generate270.companyId=='00000000-0000-0000-0000-000000000000'|| generate270.companyId==null
                                                                  ||generate270.payorId=='00000000-0000-0000-0000-000000000000'||generate270.payorId==null||generate270.clearingHouseId=='00000000-0000-0000-0000-000000000000'
                                                                  ||generate270.clearingHouseId==null||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null"
                                          (click)="generate270file()">Generate270</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="tab-pane fade show " id="nav-271" role="tabpanel" aria-labelledby="nav-271-tab"
                               >
                                <div class="row mb-2">
                                  <div class="col ">
                                    <div widget class="card border-0 box-shadow">
                                      <div class="card-header transparent  text-muted">
                                        <h4 class="mb-0 font-header">Import</h4>
                                      </div>
                                      <div class="card-body  widget-body pb-0 pt-2 mb-4">
                                        <div class="alert alert-warning alert-dismissible" *ngIf="onDOCFileChangedErr!= '' "
                                          closable (close)="onDOCFileChangedErr=''">
                                          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                                            (click)="onDOCFileChangedErr=''">
                                            <span aria-hidden="true"></span>
                                          </button>
                                          {{onDOCFileChangedErr}}
                                        </div>
    
                                        <div class="row no-gutters ">
    
    
                                          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 mt-1">
    
                                            <div class="custom-file ">
                                              <input type="file" [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                                class="custom-file-input w-50" id="customFile" #myInput name="filename"
                                                (change)="onFileChanged($event)"[(ngModel)]="filepath"
                                                (click)="myInput.value = null">
                                              <label class="custom-file-label" for="customFile">Choose file</label>
                                            </div>&nbsp;&nbsp;
    
    
    
    
    
                                          </div>
                                          <div class="col-lg-5"> <button type="button" class="btn blue-btn me-3"
                                              [disabled]="selectedFileName ==''" (click)="onDOCFileChanged()"><i
                                                class="fa fa-upload fa-lg"></i></button><br>
                                          </div>
    
    
    
                                          <div class=" col-lg-2  mt-1">
                                            <button type="button" class="btn blue-btn btn-sm"
                                              [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'" (click)="Refresh()">
                                              <i class="fa fa-repeat"> </i>Refresh
                                            </button>&nbsp;&nbsp;
                                          </div>
    
    
                                        </div>
    
                                        <div class="row">
                                          <div class="col-lg-12">
                                            <label class="text-primary">{{selectedFileName}}</label>
                                          </div>
                                        </div>
                                        <div class="col-lg-12">
                                          <ejs-grid #grid271 [dataSource]='data271 | async' [allowResizing]='true'
                                            [allowSorting]='true' *ngIf="global.globalAgencyId!='00000000-0000-0000-0000-000000000000'" [allowPaging]='true'
                                            [pageSettings]='initialPage1' [filterSettings]='filterSettings'  allowTextWrap='true'
                                            [textWrapSettings]='wrapSettings'
                                            [allowFiltering]='true' (resizeStop)="onResizeSelected($event)"
                                            (dataStateChange)='dataStateChange($event)'
                                            (actionBegin)="onActionCompleteview271($event)" [showColumnChooser]='true'>
                                            <e-columns>
                                              <e-column minWidth=100 uid="action" textAlign="center" headerText="Action"
                                                [showInColumnChooser]='false'>
                                                <ng-template #template let-data>
                                                  <button class="btn btn-edit-table text-center" [disabled]="data.importStatus?.toUpperCase()=='INPROGRESS'"
                                                    (click)="openview271(data)"><i class="fa fa-eye"></i></button>&nbsp;
                                                  <button class="btn btn-delete-table text-center" data-bs-toggle="modal"  [disabled]="data.importStatus?.toUpperCase()=='INPROGRESS'"
                                                    data-bs-target="#delete271modal" (click)="selectEDI271toDelete(data)"><i
                                                      class="fa fa-trash"></i></button>
                                                </ng-template>
                                              </e-column>
                                              <e-column minWidth=200 field="importedDate" headerText="Import Date" type="date"
                                                [format]='formatOptions'></e-column>
                                              <e-column  minWidth=250  field="fileName" headerText="File Name" type="string"   [allowTextWrap]="false">
                                                <ng-template #filterTemplate let-data>
                                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                              </e-column>
                                              <e-column minWidth=100 field="importStatus" headerText="Import Status" type="string">
                                                <ng-template #filterTemplate let-data>
                                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                              </e-column>
                                               <e-column field="isAutogenerated" headerText="Background Process" width="150" type="string" [allowFiltering]='false'>
                                                  <ng-template #template let-data>
                                                   {{ data.isAutogenerated ? 'Yes' : 'No' }}
                                                 </ng-template>                                    
                                                </e-column>
                                              <e-column minWidth=150 field="error" headerText="Error" type="string" [allowSorting]='false'
                                                [allowFiltering]='false'>
                                              </e-column>
                                              <e-column minWidth=50  [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                  <div class="d-none d-lg-block">
                                                    <span id='show' (click)='showSetting()'><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true"> </i></span>
                                                  </div>
                                                </ng-template>
                                              </e-column>
                                            </e-columns>
                                          </ejs-grid>
                                          <div *ngIf="List271Data?.length == 0" class="text-center" style="color:red">
                                            <p>No data available</p>
                                          </div>
                                        </div>
    
    
    
                                      </div>
    
                                    </div>
                                  </div>
                                </div>
    
    
    
    
    
                              </div>
                              <div class="tab-pane fade show " id="nav-view271" role="tabpanel"
                                aria-labelledby="nav-271-tab">
                              </div>
                            </div>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="view270">
      <div class="row ">
        <div class="col pl-3">
          
          <h4 class="mb-0 font-header" style="font-weight: 700; color: #502189;" ><label (click)="view270=false"><i class="fa fa-chevron-circle-left" title="Close" style="font-size:24px"></i></label>&nbsp;270 Details</h4>
        </div>
      </div>
      <div>
      
      <div class="row mb-2">
        <div class="col ">
          <div widget class="card border-0 box-shadow mt-2">
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
              <button class="btn blue-btn btn-sm float:right mr-1" (click)="Refresh270()">Refresh</button>
              <ejs-grid #gridview270 [dataSource]='data270 | async' [allowResizing]='true' allowPaging='true'
                [pageSettings]='initialPage' [allowFiltering]='true' [allowSorting]='true'
                (actionBegin)="onActionCompleteview270($event)" [filterSettings]='filterSettings'
                (dataStateChange)='dataStateChange270($event)' (resizeStop)="onResizeEligibility270($event)"
                [showColumnChooser]='true'>
                <e-columns>
                  <e-column minWidth=100 headerText="Action" uid="action" textAlign='center' [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table text-center ms-2" (click)="download270(data.filePath)"><i
                          class="fa fa-download"></i></button>
                      <button class="btn btn-edit-table text-center ms-2" data-bs-toggle="modal" data-bs-target="#view270"
                        (click)="openview270(data.id)"><i class="fa fa-eye "></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="companyName" headerText="Company" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="clearingHouseName" headerText="Clearing House" type="string"
                    [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="fileName" headerText="File Name" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                   <e-column field="isAutogenerated" headerText="Background Process" width="150" type="string" [allowFiltering]='false'>
                   <ng-template #template let-data>
                      {{ data.isAutogenerated ? 'Yes' : 'No' }}
                    </ng-template>                                    
               </e-column>
                  <e-column minWidth=100 field="createDate" type='date' headerText="Generated Date"
                    [format]='formatOptions'></e-column>
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <!-- (click)='show()' -->
                        <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                          </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
              <div *ngIf="dataviewList270?.length == 0" class="text-center" style="color:red">
                <p>No data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    <!-------------------------------create 270 ----------------------------------------------------->
    <span id="openModal1" data-bs-target="#Create270Detail" data-bs-toggle="modal"></span>
    <div class="modal fade" id="Create270Detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-header">Created 270 Details</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
           
            <table class="table  table-hover table-bordered mt-3">
              <thead style="min-width: 100px;position: relative;color:white;background-color:   #502189;">
                <th class="pointer"   style="min-width: 100px;position: relative;color:white;background-color:   #502189;;">S No.
                </th>
                <th class="pointer">Filepath
                </th>
                <th class="pointer" style="text-align: center;">Download
                </th>
                <th class="pointer" style="text-align: center;">View
                </th>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center p-0" style="width: 65px; vertical-align: middle;background-color: whitesmoke;color: black;">
                    1
                  </td>
                  <td style="width: 57%; word-break:break-all; vertical-align: middle;">
                    {{created270?.fileName}}
                  </td>
                  <td class="text-center p-0" style="vertical-align: middle;">
                    <button class="btn blue-btn btn-sm ms-2" (click)=download270(created270.filePath)> <i
                        class="fa fa-download" aria-hidden="true"></i></button>
                  </td>
                  <td class="text-center p-0" style="vertical-align: middle;">
                    <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#view270" (click)="viewFiles=true">
                      <i class="fa fa-eye" aria-hidden="true"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
        
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button class="btn blue-btn btn-sm text-right" type="button" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-------------------------------view270 270 ----------------------------------------------------->
    <span id="openModal2" data-bs-target="#view270" data-bs-toggle="modal"></span>
    <div class="modal fade" id="view270" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog1 modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header modal-header1 border-0">
            <h5 class="modal-title text-left font-header">270 Record</h5>
            <div class="ms-auto d-flex gap-2 align-items-center">
              <button class="btn blue-btn btn-sm" (click)="kendopdfdownloadList()">
                Download
              </button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="viewFiles=false"></button>
            </div>
          </div>
          <div class="modal-body modal-body1">
            <div class="row">
              <div class="col-lg-12">
                <kendo-pdf-export #pdflist paperSize="A4">
                  <div style="width:730px;padding-left: 15px;">
                    <div class="row">
                      <div class="col-lg-10 font-weight-bold">
                        <h5>270 Report</h5>
                      </div>
                      <div class="col-lg-2 font-weight-bold">
                        {{today|date:'MM/dd/yyyy'}}
                      </div>
                    </div>
    
                    <div *ngIf="viewFiles">
                      <div class="font-weight-bold">{{created270.payerDetail.payer_Name}}</div>
    
                      <div class="font-weight-bold">{{created270.payerDetail.payer_Address_1}}</div>
    
                      <div class="font-weight-bold">{{created270.payerDetail.payer_City}}
                        ,&nbsp;{{created270.payerDetail.payer_State}}
                        ,&nbsp;{{created270.payerDetail.payer_Zip}}</div>
                      <div class="font-weight-bold">PayerID:{{created270.payerDetail.billing_payor_ID}}</div>
                      <hr style="
                        margin-top: 1.5%;
                        border-top: 1px solid rgb(19, 17, 17);
                        width: 100%;
                        box-shadow: 0px 1px 1px #0c0c0c;
                        " />
                      <div class="row w-100">
                        <div class="col-lg-4">
                          <div class="font-weight-bold">{{created270.companyDetail.company_Name}}</div>
                          <div class="font-weight-bold">{{created270.companyDetail.company_Address_1}}</div>
                          <div class="font-weight-bold">
                            {{created270.companyDetail.company_City}},&nbsp;{{created270.companyDetail.company_State}}
                            ,&nbsp;{{created270.companyDetail.company_Zip}}</div>
                        </div>
                        <div class="col-lg-4"></div>
                        <div class="col-lg-4">
    
                          <div class="font-weight-bold">
                            Date:&nbsp;&nbsp;&nbsp;&nbsp;{{created270.created_Date|date:'MM/dd/yyyy'}}</div>
    
                        </div>
                      </div>
                      <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />
                      <span class="mt-1"></span>
    
                      <hr style="
                            margin-top: 1.5%;
                            border-top: 1px solid rgb(19, 17, 17);
                            width: 100%;
                            box-shadow: 0px 1px 1px #0c0c0c;
                            " />
                      <div class="row w-100">
    
                        <div class="col-lg-4">
                          Name
                        </div>
                        <div class="col-lg-2">
                          DOB
                        </div>
                        <div class="col-lg-3">
                          Gender
                        </div>
                        <div class="col-lg-3">
                          Insurence No
                        </div>
                      </div>
                      <hr style="
                            margin-top: 1.5%;
                            border-top: 1px solid rgb(19, 17, 17);
                            width: 100%;
                            box-shadow: 0px 1px 1px #0c0c0c;
                            " />
                      <ng-container *ngFor="let val1 of created270.clinetDetail">
                        <div class="row w-100">
                          <div class="col-lg-4">
                            {{val1.clinet_LastName}},&nbsp;{{val1.clinet_FirstName}} &nbsp;{{val1.cLient_MiddleName}}
                          </div>
                          <div class="col-lg-2">
                            {{val1.client_DOB|date:'MM/dd/yyyy'}}
                          </div>
                          <div class="col-lg-3">
                            <span *ngIf="val1.client_Gender=='F'">
                              FEMALE
                            </span>
                            <span *ngIf="val1.client_Gender=='M'">
                              MALE
                            </span>
                          </div>
                          <div class="col-lg-3">
                            {{val1.client_Insurance}}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </kendo-pdf-export>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="viewFiles=false">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------------view 271 ----------------------------------------------------->
    <span id="openModal3" data-bs-target="#view271" data-bs-toggle="modal"></span>
    <div class="modal fade" id="view271" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog User-Add-ModelEB271" role="document">
        <div class="modal-content">
          <div class="modal-header modal-header1 border-0">
            <h5 class="modal-title text-left font-header">271 Record</h5>
            <div class="ms-auto d-flex gap-2 align-items-center">
              <button class="btn blue-btn btn-sm" (click)="kendopdfdownloadList271()">
                Download
              </button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clear271Preview()"></button>
            </div>
          </div>
          <div class="modal-body modal-body1" style="height: auto;">
            <div class="row">
              <div class="col-lg-12">
                <iframe *ngIf="safePdfSrc" [src]="safePdfSrc" style="width: 100%; height: 500px; border: 0;"></iframe>
              </div>
            </div>
          </div>
          <div class="modal-footer">
    
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
              (click)="clear271Preview()">Cancel</button>
          </div>
    
        </div>
      </div>
    </div>
    
    <app-vieweligibility271 (close271)="make271false()" *ngIf="view271client">
    
    </app-vieweligibility271>
    
    <!-- ====================================================Delete Modal====================================== -->
    <span id="delete271modalopen" data-bs-target="#delete271modal" data-bs-toggle="modal"></span>
    <div class="modal fade" id="delete271modal" data-bs-backdrop="static">
      <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-header">Delete Record</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label>Do you want to delete this record ?</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn blue-btn btn-sm" (click)="deleteEDI271()">Delete</button>
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>